import { render, staticRenderFns } from "./activity-feed.vue?vue&type=template&id=929061e6&scoped=true&"
import script from "./activity-feed.vue?vue&type=script&lang=js&"
export * from "./activity-feed.vue?vue&type=script&lang=js&"
import style0 from "./activity-feed.vue?vue&type=style&index=0&id=929061e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929061e6",
  null
  
)

export default component.exports